import { HoverText, Icon } from '@advanza/ui'
import { useNavigate } from 'react-router-dom'

interface DuplicateProviderBadgeProps {
    duplicateProfileId: number | null
    currentProviderId: number
}

const DuplicateProviderBadge = ({ duplicateProfileId }: DuplicateProviderBadgeProps) => {
    const navigate = useNavigate()

    if (!duplicateProfileId) {
        return null
    }

    const handleClick = () => {
        navigate(`/service/providers/provider/${duplicateProfileId}`)
    }

    return (
        <HoverText
            trigger={
                <Icon
                    name="people"
                    orange
                    onClick={handleClick}
                    style={{ cursor: 'pointer', marginLeft: '2px' }}
                />
            }>
            View duplicate profile
        </HoverText>
    )
}

export default DuplicateProviderBadge
